const updates = [
  { date: '2026-07-31', title: '《迷雾追踪》第二季全集上线，悬疑升级口碑炸裂', tag: '新剧' },
  { date: '2026-07-30', title: '暑期特别策划：十部必看科幻电影高清修复版上线', tag: '专题' },
  { date: '2026-07-29', title: '播放线路全面升级，新增三条高速CDN节点', tag: '系统' },
  { date: '2026-07-28', title: '《星际之门：起源》4K超清版独家上线被窝网电影', tag: '新片' },
  { date: '2026-07-27', title: '国产动画《山海经之再见怪兽》全网首发热播中', tag: '新片' },
  { date: '2026-07-26', title: '移动端播放器更新：新增手势调节亮度和音量功能', tag: '系统' },
  { date: '2026-07-25', title: '韩剧《无声的告白》豆瓣9.1分，本周最热必追', tag: '热播' },
  { date: '2026-07-24', title: '片库突破10万+，成为国内最大免费影视聚合平台之一', tag: '里程碑' },
];

const tagColors: Record<string, string> = {
  '新剧': 'bg-primary-100 text-primary-700',
  '专题': 'bg-accent-100 text-accent-700',
  '系统': 'bg-secondary-100 text-secondary-700',
  '新片': 'bg-primary-100 text-primary-700',
  '热播': 'bg-accent-100 text-accent-700',
  '里程碑': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-2">Updates</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            被窝网电影每日动态，不错过任何精彩
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 before:absolute before:left-[11px] before:top-2 before:bottom-2 before:w-0.5 before:bg-background-200">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pb-8 last:pb-0">
                <div className="absolute left-[-30px] top-1 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-100 z-10"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                  <p className="text-sm text-foreground-700 font-medium leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}